var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.5333 3.46732C16.6 1.53398 13.9467 0.333984 11 0.333984C5.10668 0.333984 0.34668 5.10732 0.34668 11.0007C0.34668 16.894 5.10668 21.6673 11 21.6673C15.9733 21.6673 20.12 18.2673 21.3067 13.6673H18.5333C17.44 16.774 14.48 19.0007 11 19.0007C6.58668 19.0007 3.00001 15.414 3.00001 11.0007C3.00001 6.58732 6.58668 3.00065 11 3.00065C13.2133 3.00065 15.1867 3.92065 16.6267 5.37398L12.3333 9.66732H21.6667V0.333984L18.5333 3.46732Z","fill":"#0067DD"}));
}

Icon.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = Icon;

Icon.default = Icon;
